import { CloudStoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";

import CreateApiModule from "@/redux/create-api-module";
import { Config } from "@/utils/config.utils";

import { $ShopNamesModuleName } from "./shopNames.types";

const { actions } = CreateApiModule(
    $ShopNamesModuleName,
    () =>
        `/storeservice/${Config.general.basestore}/localized/stores/shopnames?storeType=${CloudStoreType.WalkIn}`
);

export const clear = actions.clear;
export const load = actions.load;
export const refetch = actions.refetch;
